import React from 'react';

import { Stack } from '@mui/material';

import type { WhatsNewCarouselPayloadBuilderState } from '~/utils/societePayloadBuilder/whatsNewCarousel/types';

import { PAYLOAD_BUILDER_REQUIRED_FIELDS_SX } from '../FieldLabels';
import LoadPayloadSection from '../LoadPayloadSection';

import WhatsNewCarouselCardsSection from './WhatsNewCarouselCardsSection';

interface WhatsNewCarouselPayloadBuilderFormProps {
  collapseResetKey: number;
  state: WhatsNewCarouselPayloadBuilderState;
  onChange: (next: WhatsNewCarouselPayloadBuilderState) => void;
  loadJson: string;
  onLoadJsonChange: (value: string) => void;
  loadError: string | null;
  loadCollapseKey?: number;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function WhatsNewCarouselPayloadBuilderForm({
  collapseResetKey,
  state,
  onChange,
  loadJson,
  onLoadJsonChange,
  loadError,
  loadCollapseKey,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: WhatsNewCarouselPayloadBuilderFormProps) {
  return (
    <Stack spacing={2}>
      <LoadPayloadSection
        loadJson={loadJson}
        loadError={loadError}
        collapseKey={loadCollapseKey}
        onLoadJsonChange={onLoadJsonChange}
        onLoadPayload={onLoadPayload}
        onClearLoad={onClearLoad}
        onUploadFile={onUploadFile}
      />

      <Stack key={collapseResetKey} sx={PAYLOAD_BUILDER_REQUIRED_FIELDS_SX}>
        <WhatsNewCarouselCardsSection cards={state.cards} onChange={(cards) => onChange({ ...state, cards })} />
      </Stack>
    </Stack>
  );
}
